import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Button, Form, Upload } from "antd";
import { OrderedMap, List } from "immutable";
import { readSpreadsheet } from "utilities/excel-utils";
import "styles/form.css";
import { STATE_STATUS } from "../constants";
import { Table } from "components";
import history from "../router/history";


class PaymentProgramForm extends React.Component {
    state = {
        new_paypro_list: new List([])
    };

    PAYPRO_CASES_COLS = new OrderedMap({
        State: {
            title: "State",
            dataIndex: "State",
            key: "State",
        },
        ao_code: {
            title: "AO Code",
            dataIndex: "AO Code",
            key: "AO Code",
        },
        ao_name: {
            title: "AO Name",
            dataIndex: "AO Name / Location",
            key: "ao_name",
        },
        Zone: {
            title: "Zone",
            dataIndex: "Zone",
            key: "Zone",
        },
        sub_dealer_name: {
            title: "Sub Dealer Name",
            dataIndex: "Sub Dealer Name",
            key: "sub_dealer_name",
        },
        sub_dealer_code: {
            title: "Sub Dealer Code",
            dataIndex: "Sub Dealer Code",
            key: "sub_dealer_code",
        },
        main_dealer_name: {
            title: "Main Dealer Name",
            dataIndex: "Main Dealer Name",
            key: "main_dealer_name",
        },
        main_dealer_code: {
            title: "Main Dealer Code",
            dataIndex: "Main Dealer Code",
            key: "main_dealer_code",
        },
        email: {
            title: "Email",
            dataIndex: "E Mail Address",
            key: "email",
        },
        gstin_no: {
            title: "GST No",
            dataIndex: "GST No",
            key: "gstin_no",
        },
        payer_gstin: {
            title: "Payer GST No",
            dataIndex: "Payer GST No",
            key: "payer_gstin",
        }
    });

    onRemove = row => {
        let existingData = this.state.new_paypro_list;
        existingData = existingData.filter(_ => _.key != row.key);
        this.setState({
            new_paypro_list: existingData
        });
    }

    componentDidUpdate(prevProps) {
        if(prevProps.status === STATE_STATUS.CREATING && this.props.status === STATE_STATUS.CREATED){
            this.setState({
                new_paypro_list: new List([])
            });

            history.replace("/app/payment-program/?ordering=1");
        }
    }

    saveCases = () => {
        let data = this.state.new_paypro_list && this.state.new_paypro_list.size ? 
            this.state.new_paypro_list.toArray() : [];
        data = data.map((data) => {
            return {
                state: data["State"],
                ao_code: data["AO Code"],
                ao_name: data["AO Name / Location"],
                zone: data["Zone"],
                sub_dealer_name: data["Sub Dealer Name"],
                sub_dealer_code: data["Sub Dealer Code"],
                main_dealer_name: data["Main Dealer Name"],
                main_dealer_code: data["Main Dealer Code"],
                email: data["E Mail Address"],
                gstin_no: data["GST No"],
                payer_gstin: data["Payer GST No"]
            };
        });
        this.props.createBulkPayProCase(data);
    };

    readFile = async (file) => {
        let data = await readSpreadsheet(file);
        Promise.all(data).then((values) => {
            data = new List([...values, ...this.state.new_paypro_list]);
            this.setState({
                new_paypro_list: data,
            });
        });
    };


    downloadSampleSheet = () => {
        return import(/* webpackChunkName: "xlsx" */ "xlsx")
            .then(_ => _.default)
            .then(async XLSX => {
                let cols = this.PAYPRO_CASES_COLS.map(_ => _.dataIndex).toList();
                let ws = await XLSX.utils.json_to_sheet([], {header: cols.toArray()});
                let wb = await XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
                const wbout = XLSX.writeFile(wb, "sample-payment-program-cases.xlsx");
                return wbout;
            });
    }

    render() {
        return (
            <Row>
                <Col span={24} className={"d-flex justify-content-center"}>
                    <div>
                        <Button type={"primary"} icon={"download"} onClick={this.downloadSampleSheet} className={"mr-10"}>
                            {"Download Sample Sheet"}
                        </Button>
                        <Upload
                            beforeUpload={(file) => this.readFile(file)}
                            action={null}
                        >
                            <Button type={"primary"} icon={"upload"}>
                                {"Upload Data Sheet"}
                            </Button>
                        </Upload>
                    </div>
                </Col>
                <Col span={24} className={"mt-10"}>
                    {this.state.new_paypro_list.size ? <Table
                        columns={this.PAYPRO_CASES_COLS}
                        type={"inner"}
                        showTopSection={false}
                        showHeader={true}
                        noRowSelection={true}
                        data={this.state.new_paypro_list}
                    /> : null}
                </Col>
                {this.state.new_paypro_list.size ? <Col span={24} className={"mt-10 d-flex justify-content-center"}>
                    <Button type={"primary"} size={"small"} onClick={this.saveCases}>Submit</Button>
                </Col> : null}
            </Row>
        );
    }

}

PaymentProgramForm.propTypes = {
    form: PropTypes.object,
    createBulkPayProCase: PropTypes.func,
    status: PropTypes.string
};

export default Form.create({})(PaymentProgramForm);
